import { Instagram, Facebook, MapPin, Phone, Clock, Wallet } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { PUBLIC_BOOKING } from "@/constants/testIds";
import { PAYMENT_METHOD_LABELS } from "@/lib/patientConstants";

export default function PublicFooter({ clinic }) {
  const { t } = usePublicLang();
  const hasSocial = clinic.instagram_url || clinic.facebook_url;

  return (
    <footer className="py-10 sm:py-12 text-center flex flex-col items-center gap-4 border-t border-black/5 mt-4" data-testid={PUBLIC_BOOKING.footer}>
      {hasSocial && (
        <div className="flex items-center gap-4">
          {clinic.instagram_url && (
            <a
              href={clinic.instagram_url}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center text-[var(--brand-primary)] hover:scale-105 transition-transform"
              data-testid={PUBLIC_BOOKING.instagramLink}
            >
              <Instagram className="w-5 h-5" />
            </a>
          )}
          {clinic.facebook_url && (
            <a
              href={clinic.facebook_url}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center text-[var(--brand-primary)] hover:scale-105 transition-transform"
              data-testid={PUBLIC_BOOKING.facebookLink}
            >
              <Facebook className="w-5 h-5" />
            </a>
          )}
        </div>
      )}
      <div className="text-sm text-[#5C554D] space-y-1">
        {clinic.address && <p className="flex items-center gap-1.5 justify-center"><MapPin className="w-3.5 h-3.5" />{clinic.address}</p>}
        {clinic.phone && <p className="flex items-center gap-1.5 justify-center"><Phone className="w-3.5 h-3.5" />{clinic.phone}</p>}
        {clinic.business_hours_text && (
          <p className="flex items-start gap-1.5 justify-center whitespace-pre-line"><Clock className="w-3.5 h-3.5 shrink-0 mt-0.5" />{clinic.business_hours_text}</p>
        )}
        {clinic.accepted_payment_methods?.length > 0 && (
          <p className="flex items-center gap-1.5 justify-center" data-testid={PUBLIC_BOOKING.acceptedPaymentMethods}>
            <Wallet className="w-3.5 h-3.5" />
            Aceptamos {clinic.accepted_payment_methods.map((m) => PAYMENT_METHOD_LABELS[m] || m).join(", ")}
          </p>
        )}
      </div>
      <p className="text-xs text-[#5C554D]/70">{clinic.name} — {t("footer.rights")}</p>
    </footer>
  );
}
